module.exports = __webpack_public_path__ + "img/chevron-left.b855f45f.svg";